import { useState } from "react";
import { classNames } from "../../../utils/classNames";
import { Skeleton } from "../../DecisionTesting/Skeleton";
import { CircleIcon } from "./CircleIcon";

export function CircleIconWithTooltip({
  count,
  label,
  include0,
  bottom
}: {
  count: number | undefined;
  label: string;
  include0?: boolean;
  bottom?: boolean;
}) {
  const [isHovered, setIsHovered] = useState(false);
  if (count === 0 && !include0) {
    return null;
  }

  if (!count) {
    return (
      <div className="">
        <Skeleton className="w-5 h-5" />
      </div>
    );
  }

  return (
    <div
      className="relative transition transform hover:scale-125 "
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div>
        <CircleIcon number={count} include0={true} />
      </div>
      {isHovered && (
        <div
          className={classNames(
            "bg-white rounded-lg text-sm font-normal shadow absolute left-1/2 transform -translate-x-1/2 p-4 z-50",
            bottom ? "top-full" : "bottom-full"
          )}
        >
          <span className="text-blue-600 flex items-center justify-center">
            {label}
          </span>
        </div>
      )}
    </div>
  );
}
